import { Box } from "@mui/material";

type Props = {
  marginTop: number;
};

export const Spacer = ({ marginTop }: Props) => {
  return (
    <Box
      sx={{
        marginTop: `${marginTop}px`,
      }}
    />
  );
};
